import { Component, ViewEncapsulation, Input, TemplateRef, ViewContainerRef, AfterViewInit } from '@angular/core';
import { WlxTabComponent } from './tab.component';
import { TabsController } from './tabs.service';
import { state, trigger, style, animate, transition } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { WlRegexReplacePipe } from '../../pipes/regex-replace.pipe';
import { TabWellContentViewDirective } from './tab-well-content-view.directive';

/**
 * a way to recursively build the tabs
 */
@Component({
  selector: '[wlx-tab-view]',
  templateUrl: 'tab-view.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    WlRegexReplacePipe,
    TabWellContentViewDirective
   ],
  animations: [
    trigger('slideReveal', [
      state(
        'revealed',
        style({
          overflow: 'hidden',
          height: '*',
        })
      ),
      state(
        'hidden',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      transition('hidden => revealed', animate('400ms ease-in-out')),
      transition('revealed => hidden', animate('400ms ease-in-out')),
    ]),
  ],
})
export class WlxTabViewComponent {
  @Input() public tabs: Array<WlxTabComponent> = [];
  @Input() public collapseSubTabs = false;

  /**
   * construct
   * @param _tabsCtrl
   */
  public constructor(public _tabsCtrl: TabsController) {}

  /**
   * select the given tab
   * @param tab
   */
  public select(tab: WlxTabComponent) {
    this._tabsCtrl.select(tab);
  }
}
